import React from 'react';
import { TERMS_OF_USE_HTML } from './termsOfUseContent';
import '../legalDoc.scss';

/**
 * Full Terms of Use, content ported verbatim from Laravel's
 * terms-of-use.blade.php (Laravel serves it at /terms-use).
 */
export const TermsOfUse: React.FC = () => {
  return (
    <div>
      <div className="bg-white border-b border-slate-200 py-2 px-6 flex items-center">
        <img src="/assets/images/logo.png" alt="Facilon" style={{ height: 40, objectFit: 'contain' }} />
      </div>
      <div className="public-page bg-slate-50 py-8 min-h-screen">
        <div className="container max-w-5xl mx-auto px-4 space-y-6">
          <div className="bg-[#052f55] p-6 rounded-xl shadow-sm">
            <h1 className="text-2xl font-bold m-0 flex items-center gap-2 text-white" style={{ color: '#ffffff' }}>
              <i className="bi bi-journal-text text-red-500"></i>
              <span>Terms of Use</span>
            </h1>
            <p className="text-slate-300 text-xs mt-1 mb-0">
              The terms that apply to your use of the Facilon platform.
            </p>
          </div>
          <div
            className="bg-white border border-slate-200 rounded-xl p-6 shadow-xs legal-doc"
            dangerouslySetInnerHTML={{ __html: TERMS_OF_USE_HTML }}
          />
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
